import './TechItem.css'

export default function TechItem({ src, title, description }) {
	return (
        <div className="tech-item">
            <div className="tech-item__main">
                <img src={src} alt={title} class="tech-item__img" />
                <h5>{ title }</h5>
            </div>
            <p className="tech-item__text">{ description }</p>
        </div>
	);
}